<template>
  <card card-body-classes="table-full-width">
    <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <h4 slot="header" class="card-title">{{ $t('accountEmvTaps.title') }}</h4>
    </div>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>

        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :row-class-name="tableRowClassName"
                :cell-class-name="tableCellClassName"
                :empty-text="$t('generic.noData')">
        <el-table-column type="expand">
          <template slot-scope="props">
            <emv-tap-details :details="props.row"/>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :prop="column.prop"
          :label="$t(column.label)"
          :formatter="column.formatter"
          :min-width="column.minWidth"
          :width="column.width"
        >
        </el-table-column>
        <el-table-column align="right" width="50">
          <div slot-scope="props">
            <router-link
              :to="{name: 'account-emv-tap-details', params: {id: props.row.account_id, resource_id: props.row.id}}">
              <i class="tim-icons icon-double-right"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import {mapActions, mapState} from "vuex";
import EmvTapDetails from 'src/components/EmvTap/EmvTapDetails'

export default {
  name: 'AccountEmvTaps',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    EmvTapDetails
  },
  methods: {
    ...mapActions(['LoadAccountEmvTaps']),
    tableRowClassName({row}) {
      switch (row["status"]) {
        case "in_clearing":
          return 'bg-secondary';
        case "clearing_failed":
        case "payment_failed":
          return 'bg-warning';
        case "payment_applied":
          return 'active_row';
      }
      return '';
    },
    tableCellClassName({row, column}) {

      if (column.property !== 'emv_external_tap_id') {
        return ''
      }

      if (row['emv_external_tap_id'] !== null) {
        return '';
      }

      return 'bg-danger';
    },
  },
  computed: {
    ...mapState({
      loading: state => state.account_emv_taps.loading,
      data: state => state.account_emv_taps.data,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['request_id'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 200,
        },
        {
          prop: 'id',
          label: 'generic.id',
        },
        {
          prop: 'status',
          label: 'generic.status',
          width: 150,
        },
        {
          prop: 'type',
          label: 'emvTap.details.type',
          width: 150,
        },
        {
          prop: 'request_id',
          label: 'emvTap.details.request_id',
        },
        {
          prop: 'business_day',
          label: 'emvTap.details.business_day',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.dateOnly(cellValue)
          },
          width: 150,
        },
        {
          prop: 'emv_external_tap_id',
          label: 'emvTap.details.emv_external_tap_id',
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  mounted() {
    this.LoadAccountEmvTaps(this.$route.params.id)
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "data"(entries) {
      this.tableData = entries;
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
